import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

function getCartSectionIds() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
    ids.add(el.dataset.sectionId);
  });
  return Array.from(ids);
}

async function addRecommendedProduct(button) {
  if (button.disabled) return;
  const variantId = button.dataset.variantId;
  if (!variantId) return;

  button.disabled = true;
  button.classList.add('loading');

  const sectionIds = getCartSectionIds();
  const deferred = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      const message = data.description || data.message || 'Could not add item to cart';
      deferred.reject(new Error(message));
      document.dispatchEvent(new CartErrorEvent({ error: message, code: 'INVALID' }));
      return;
    }

    // /cart/add.js only returns the added line item — createCartFromAjaxResponse
    // needs the full cart shape, so fetch it explicitly.
    const cartResponse = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    const fullCart = await cartResponse.json();

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(fullCart),
      detail: {
        sections: data.sections,
        items: fullCart.items,
        source: 'cart-recommendation-carousel',
        didError: false,
      },
    });

    // --- UPDATED SUCCESS STATE FOR SVG ICON ---
    const cartSvg = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>`;
    const checkSvg = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4ade80" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`;

    button.innerHTML = checkSvg;
    setTimeout(() => { 
      button.innerHTML = cartSvg; 
    }, 1200);

  } catch (error) {
    deferred.reject(error);
    document.dispatchEvent(
      new CartErrorEvent({ error: error?.message || 'Failed to add item to cart', code: 'SERVICE_UNAVAILABLE' })
    );
  } finally {
    button.disabled = false;
    button.classList.remove('loading');
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('.add-to-cart-recommendation');
  if (!button) return;
  event.preventDefault();
  addRecommendedProduct(button);
});

document.addEventListener('click', function (e) {
  if (e.target.closest('.cart-carousel-next')) {
    const wrapper = e.target.closest('.cart-drawer__recommendations');
    wrapper.querySelector('.cart-drawer__carousel').scrollBy({ left: 200, behavior: 'smooth' });
  }
  if (e.target.closest('.cart-carousel-prev')) {
    const wrapper = e.target.closest('.cart-drawer__recommendations');
    wrapper.querySelector('.cart-drawer__carousel').scrollBy({ left: -200, behavior: 'smooth' });
  }
});

// ==========================================
// AUTO-CLOSE ACCORDION ON CART UPDATE
// ==========================================
let accordionTimeout;

function checkAccordionState() {
  clearTimeout(accordionTimeout);
  
  // Wait 400ms for the theme's cart drawer JS to finish updating the DOM
  accordionTimeout = setTimeout(() => {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(res => res.json())
      .then(cart => {
        const details = document.querySelector('.cart-drawer__recommendations');
        if (details) {
          // If cart reaches 79900 (₹799) or above, remove the 'open' attribute
          if (cart.total_price >= 79900) {
            details.removeAttribute('open');
          }
        }
      })
      .catch(err => console.error('Failed to check cart total for accordion:', err));
  }, 400);
}

// Watch the cart drawer for any DOM changes (quantity clicks, item additions, etc.)
const cartObserver = new MutationObserver((mutations) => {
  // Only trigger if the change is happening inside the cart items or summary
  const relevantChange = mutations.some(m => {
    return m.target.closest('.cart-items-component') || 
           m.target.closest('.cart-drawer__summary') ||
           m.target.closest('.cart-drawer__inner');
  });

  if (relevantChange) {
    checkAccordionState();
  }
});

// Initialize observer when DOM is ready
function initCartObserver() {
  const cartInner = document.querySelector('.cart-drawer__inner');
  if (cartInner) {
    cartObserver.observe(cartInner, { childList: true, subtree: true, characterData: true });
  } else {
    // If drawer isn't in the DOM yet, retry in 1 second
    setTimeout(initCartObserver, 1000);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartObserver);
} else {
  initCartObserver();
}